import { render, staticRenderFns } from "./MemberAdminAdd.vue?vue&type=template&id=20c5cc62"
import script from "./MemberAdminAdd.vue?vue&type=script&lang=js"
export * from "./MemberAdminAdd.vue?vue&type=script&lang=js"
import style0 from "./MemberAdminAdd.vue?vue&type=style&index=0&id=20c5cc62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports